export default {

  // 新增辅料入厂验收
  insertPaAuxiliaryInspection: '/ygsjzs/paAuxiliaryInspection/insertPaAuxiliaryInspection',
  // 修改辅料入厂验收
  updatePaAuxiliaryInspection: '/ygsjzs/paAuxiliaryInspection/updatePaAuxiliaryInspection',

  // 删除辅料入厂验收
  deletePaAuxiliaryInspection: '/ygsjzs/paAuxiliaryInspection/deletePaAuxiliaryInspection',

  // 查询辅料入厂验收详情
  selectPaAuxiliaryInspectionByInspectId: '/ygsjzs/paAuxiliaryInspection/selectPaAuxiliaryInspectionByInspectId',

  // 分页查询辅料入厂验收列表
  selectPaAuxiliaryInspectionByPage: '/ygsjzs/paAuxiliaryInspection/selectPaAuxiliaryInspectionByPage'

}
